enum ERROR_API_CODE {
  OFFLINE_APP_ACCESS_DISABLED = 'OFFLINE_APP_ACCESS_DISABLED',
  DEFAULT_NOT_PERMISSION = 'DEFAULT_NOT_PERMISSION',
}

export default ERROR_API_CODE;
